<template>
  <div>
    <div class="container-fluid">
      <div class="form-container">
        <form
          method="POST"
          class="form py-4 col-lg-4 col-md-7 col-sm-9 col-11 mx-auto"
        >
          <h4 class="text-center my-3 form-heading">
            Welcome to Bookinga sign up
          </h4>

          <p
            class="errors mb-3 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="error"
            v-show="NewError"
          ></p>

          <p
            class="success mb-3 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="success"
            v-show="success"
          ></p>

          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="text"
              class="form-control"
              placeholder="Enter First name "
              name="firstname"
              id="firstname"
              v-model="data.Firstname"
              autocomplete="offset"
              required
            />

            <!-- <label class="form-label" for="firstname">First name</label> -->
          </div>

          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="text"
              class="form-control"
              placeholder="Enter Last name"
              name="lastname"
              id="lastname"
              v-model="data.Lastname"
              required
            />

            <!-- <label class="form-label" for="lastname">Last name</label> -->
          </div>

          <div class="form-group col-lg-10 mx-auto col-md-10 col-11 col-sm-10">
            <!-- <label class="form-labe" for="phoneCodes">Phone number</label> -->

            <br />

            <span class="f-small"
              >*First select the country phone code then fill the remaining
              numbers in the phone number box*</span
            >

            <select
              class="form-control"
              v-model="data.selector"
              @change="getCode()"
              name="phoneCodes"
              id="phoneCodes"
              required
            >
              <option
                v-for="phoneCode in phoneCodes"
                v-bind:value="phoneCode.code"
                :key="phoneCode.code"
              >
                {{ phoneCode.code }} --
                {{ phoneCode.name }}
              </option>
            </select>
          </div>

          <div class="input-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{
                currentCode
              }}</span>
            </div>

            <input
              type="number"
              class="form-control"
              placeholder="Phone number"
              name="phone"
              id="phone"
              v-model="data.phone"
              aria-describedby="basic-addon1"
              required
            />
          </div>

          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <select
              class="form-control"
              v-model="data.Gender"
              name="gender"
              id="gender"
              required
            >
              <option disabled value>--Select gender--</option>

              <option value="M">Male</option>

              <option value="F">Female</option>
            </select>
          </div>

          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="password"
              class="form-control"
              v-model="data.password"
              placeholder="Enter password "
              name="pwd"
              id="pwd"
              minlength="6"
              required
            />

            <!-- <label class="form-label" for="pwd">Password</label> -->
          </div>

          <div class="form-group mx-auto col-lg-10 col-md-10 col-11 col-sm-10">
            <input
              v-if="showPassword"
              type="text"
              v-model="data.passwordConfirm"
              class="form-control"
              placeholder="Confirm password"
              name="pwdconf"
              minlength="6"
              id="pwdconf"
              required
            />

            <input
              v-else
              type="password"
              v-model="data.passwordConfirm"
              class="form-control"
              placeholder="Confirm password"
              name="pwdconf"
              minlength="6"
              required
              id="pwdconf"
            />

            <!-- <label class="form-label" for="pwdconf" data-toggle="password">Password confirm</label> -->

            <svg
              class="pwd-icon"
              v-if="!showPassword"
              @click="toggleShow"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />

              <path
                d="M17.882 19.297A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 0 1 3.34-6.066L1.392 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31zM5.935 7.35A8.965 8.965 0 0 0 3.223 12a9.005 9.005 0 0 0 13.201 5.838l-2.028-2.028A4.5 4.5 0 0 1 8.19 9.604L5.935 7.35zm6.979 6.978l-3.242-3.242a2.5 2.5 0 0 0 3.241 3.241zm7.893 2.264l-1.431-1.43A8.935 8.935 0 0 0 20.777 12 9.005 9.005 0 0 0 9.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.592zm-9.084-9.084a4.5 4.5 0 0 1 4.769 4.769l-4.77-4.769z"
              />
            </svg>

            <!-- open eye -->

            <svg
              class="pwd-icon"
              v-if="showPassword"
              @click="toggleShow"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />

              <path
                d="M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3zm0 16a9.005 9.005 0 0 0 8.777-7 9.005 9.005 0 0 0-17.554 0A9.005 9.005 0 0 0 12 19zm0-2.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
              />
            </svg>
          </div>

          <div class="text-center">
            <button
              type="submit"
              @click.prevent="createAccount"
              class="btn btn_styles btn-md btn-primary"
            >
              Signup now
              <span
                v-if="hasSubmitted"
                class="spinner-border spinner-border-sm ml-2 my-auto"
              ></span>
            </button>
          </div>

          <div class="text-center">
            <a class="btn btn-md mt-2 text-primary" @click="login()"
              >Login Instead</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Joi from "joi";
import phoneCodes from "./phoneCodes.json";
import router from "../../router/index.ts";
import CryptoJS from "crypto-js";
const url = "https://bookinga.herokuapp.com/api/v1/client/register";
export default {
  data() {
    return {
      currentCode: "+250",
      NewError: false,
      showPassword: false,
      UserCountryName: "",
      phoneCodes: phoneCodes.countries,
      data: {
        password: "",
        Firstname: "",
        selector: "+250",
        Lastname: "",
        phone: "",
        Gender: "",
        passwordConfirm: "",
      },
      hasSubmitted: false,
    };
  },

  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },

  created() {},
  methods: {
    getCode() {
      this.currentCode = this.data.selector;
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    login() {
      router.push("/login");
    },

    createAccount: function() {
      if (
        this.data.Lastname.length < 1 ||
        this.data.Firstname.length < 1 ||
        this.data.phone.length < 1 ||
        this.data.Gender.lenght == "" ||
        this.data.password.length == ""
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "All fields must be filled";
      } else if (
        this.data.Lastname.length < 2 ||
        this.data.Lastname.length > 41
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Last name must be more than 2 characters and not greater than 40";
      } else if (
        this.data.Firstname.length < 2 ||
        this.data.Firstname.length > 41
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "First name must be more than 2 characters and not greater than 40";
      } else if (this.data.phone.length < 3 || this.data.phone.length > 14) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "The provided phone number should be a valid phone number";
      } else if (this.data.Gender.length == "") {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Please select your gender";
      } else if (this.data.password.length < 6) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Password should be more than 5 characters";
      } else if (this.data.password !== this.data.passwordConfirm) {
        this.NewError = true;
        document.getElementById("error").innerHTML = "Passwords must match";
      } else {
        this.hasSubmitted = !this.hasSubmitted;
        axios
          .post(url, {
            Lastname: this.data.Lastname,
            Firstname: this.data.Firstname,
            Telephone: this.currentCode + this.data.phone,
            Gender: this.data.Gender,
            Password: this.data.password,
            confirmPassword: this.data.passwordConfirm,
          })
          .then((response) => {
            if (response.data.success == true) {
              var encryptedAES = CryptoJS.AES.encrypt(
                this.currentCode + this.data.phone,
                "UserWithiNoUrYuhfdnfhdsfshfsfdshgfsyrsbfdfsdsfdfdfdf909fdsfjfjsfjs"
              );
              router.push("/phoneNumberVerification/?txyz04eg=" + encryptedAES);
              this.NewError = true;
              document.getElementById("error").innerHTML =
                response.data.message;
              (this.data.password = ""),
                (this.data.Firstname = ""),
                (this.data.Lastname = ""),
                (this.data.phone = ""),
                (this.data.Gender = ""),
                (this.data.passwordConfirm = "");
            } else if (response.data.success == false) {
              this.NewError = true;
              this.hasSubmitted = !this.hasSubmitted;
              document.getElementById("error").innerHTML =
                "Invalid Phone number";
            } else {
              this.NewError = true;
              this.hasSubmitted = !this.hasSubmitted;
              document.getElementById("error").innerHTML =
                response.data.message;
            }
          })
          .catch((error) => {
            this.NewError = true;
            this.hasSubmitted = !this.hasSubmitted;
            if (error.response.data.success == false) {
              document.getElementById("error").innerHTML =
                "Telephone alread exist";
            } else if (error.response.data.err.status) {
              document.getElementById("error").innerHTML =
                "Invalid Phone number entered";
            } else {
              document.getElementById("error").innerHTML =
                error.response.data.message;
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// .form-group{
//   background-color: grey;
// }
</style>
